import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { SignatureModal } from "../../../components/Form/SignatureModel";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
import { useSettings } from "../../../context/SettingContext";
import type { LegalAdviceFormTenData } from "../../../types/LegalAdvices/LegaladviceFormTen.type";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormTenData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormTenDocument: React.FC<DetailFormDocumentProps> = ({
  formData,
//   isSigning,
//   sigCanvasRef,
//   setIsSigning,
  handleChange,
//   handleSaveSignature,
//   renderDatePicker,
  // isApproved,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
 const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
// const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
  
        <div className="w-full max-w-[850px] bg-white shadow-lg border border-gray-300 p-12 text-black space-y-12 text-xs md:text-sm leading-relaxed">
                
                {/* ခေါင်းစီးပိုင်း */}
                <div>
                  <div className="text-right text-xs font-bold">ဥပရအမှုလိုက်ပုံစံ (၁၀)</div>
                  
                  <div className="text-center space-y-2 mt-2">
                    <h1 className="text-base font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
                    <h2 className="text-sm font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
                    
                    <div className="flex justify-center items-center gap-2">
                      <DatalistInput
                        name="office"
                        value={formData.office}
                        onChange={handleChange}
                        placeholder=""
                        options={OFFICE_OPTIONS}
                      />
                      <span className="font-bold">ဥပဒေရုံး</span>
                    </div>
        
                    <div className="flex justify-center items-center pt-2">
                      <span className="font-medium">ဥပရ မှတ်ပုံတင် (</span>
                      <input type="text" name="lawRegisterNo" value={formData.lawRegisterNo} onChange={handleChange} className="w-16 bg-transparent border-b border-black text-center focus:outline-none font-bold" />
                      <span className="font-medium">) အမှတ်စဉ်</span>
                      <input 
                        type="text" 
                        name="lawRegisterNo"
                        value={formData.lawRegisterNo || ''}
                        onChange={handleChange}
                        placeholder=""
                        className="w-24 text-center bg-transparent border-b border-dotted border-black focus:outline-none"
                      />
                    </div>
        
                    <h3 className="text-sm font-bold pt-4 text-center max-w-xl mx-auto leading-normal">
                      တရားမအယူခံမှု၊ ပြင်ဆင်မှု၊ ပြန်လည်သုံးသပ်မှု၊ လွှဲအပ်မှု၊<br />
                      အထွေထွေလျှောက်ထားမှုများ ပြီးပြတ်ချက်ပုံစံ
                    </h3>
                  </div>
        
                  {/* အပိုင်း ၁။ ရုံးအချက်အလက်များ (၁ မှ ၈) */}
                  <div className="mt-8 space-y-4">
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁။</span>
                      <span className="w-72">တရားရုံးအမည်</span>
                      <input type="text" name="courtName" value={formData.courtName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၂။</span>
                      <span className="w-72">အယူခံမှု၊ ပြင်ဆင်မှု၊ ပြန်လည်သုံးသပ်မှု၊ လွှဲအပ်မှု၊ အထွေထွေလျှောက်ထားမှု အမှတ်</span>
                      <input type="text" name="appealCaseNo" value={formData.appealCaseNo} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၃။</span>
                      <span className="w-72">အယူခံတရားလို / လျှောက်ထားသူအမည်</span>
                      <input type="text" name="appellantName" value={formData.appellantName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၄။</span>
                      <span className="w-72">အယူခံတရားပြိုင် / လျှောက်ထားခံရသူအမည်</span>
                      <input type="text" name="respondentName" value={formData.respondentName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
                    </div>
        
                    <div className="flex flex-col space-y-1">
                      <div className="flex items-baseline">
                        <span className="w-10 font-bold">၅။</span>
                        <span className="flex-1">အမှုဖြစ်စဉ်အကျဥ်း</span>
                      </div>
                      <textarea name="caseSummary" value={formData.caseSummary} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                    </div>
        
                    <div className="flex flex-col space-y-1">
                      <div className="flex items-baseline">
                        <span className="w-10 font-bold">၆။</span>
                        <span className="flex-1">မူလတရားရုံးအမည်၊ အမှုအမှတ်၊ စီရင်ချက်၊ အမိန့်အတိုချုပ်နှင့် ရက်စွဲ</span>
                      </div>
                      <textarea name="originalCourtDetails" value={formData.originalCourtDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                    </div>
        
                    <div className="flex flex-col space-y-1">
                      <div className="flex items-baseline">
                        <span className="w-10 font-bold">၇။</span>
                        <span className="flex-1">တဆင့်မြင့်တရားရုံးအမည်၊ အမှုအမှတ်၊ စီရင်ချက်၊ အမိန့်အတိုချုပ်နှင့် ရက်စွဲ</span>
                      </div>
                      <textarea name="higherCourtDetails" value={formData.higherCourtDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                    </div>
        
                    <div className="flex flex-col space-y-1">
                      <div className="flex items-baseline">
                        <span className="w-10 font-bold">၈။</span>
                        <span className="flex-1">လိုက်ပါဆောင်ရွက်သောတရားရုံးအမည်၊ အမှုအမှတ်၊ စီရင်ချက် / အမိန့်အတိုချုပ်နှင့် ရက်စွဲ</span>
                      </div>
                      <textarea name="finalCourtDetails" value={formData.finalCourtDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                    </div>
                  </div>
                </div>
        
                <hr className="border-gray-300" />
        
                {/* အပိုင်း ၂။ အမှုလိုက် ဥပဒေအရာရှိ၏ လျှောက်လဲချက်အကျဉ်းနှင့် သဘောထား (၉၊ ၁၀) */}
                <div className="space-y-4">
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၉။</span>အမှုလိုက်ဥပဒေအရာရှိ၏ လျှောက်လဲချက်အကျဉ်း</label>
                    <textarea name="handlingOfficerArgumentSummary" value={formData.handlingOfficerArgumentSummary} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                  </div>
        
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၁၀။</span>အမှုလိုက်ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက်</label>
                    <textarea name="handlingOfficerOpinion" value={formData.handlingOfficerOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                  </div>
        
                  <div className="flex flex-col items-end pt-2">
                    <div className="w-64 space-y-2">
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                        <div 
                        // onClick={() => handleOpenSignatureModal('handling')} 
                        className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                          {formData.handlingOfficerSignature ? (
                            <img src={formData.handlingOfficerSignature} alt="Handling Sign" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.prosecutorSignatureImage && (
                            <button
                              type="button"
                            //   onClick={handleClearHandlingSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">အမည်</span>
                        <input type="text" name="handlingOfficerName" value={formData.handlingOfficerName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                      <div className="text-center text-xs font-bold pt-1">အမှုလိုက်ဥပဒေအရာရှိ</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <input type="text" name="handlingOfficerSubmitDate" value={formData.handlingOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                    </div>
                  </div>
                </div>
        
                <hr className="border-gray-300" />
        
                {/* အပိုင်း ၃။ တာဝန်ခံ ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက် (၁၁) */}
                <div className="space-y-4">
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၁၁။</span>တာဝန်ခံ ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက်</label>
                    <textarea name="inChargeOfficerOpinion" value={formData.inChargeOfficerOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
                  </div>
        
                  <div className="flex flex-col items-end pt-2">
                    <div className="w-64 space-y-2">
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                        <div 
                        // onClick={() => handleOpenSignatureModal('incharge')} 
                        className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                          {formData.inChargeOfficerSignature ? (
                            <img src={formData.inChargeOfficerSignature} alt="In-charge Sign" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.prosecutorSignatureImage && (
                            <button
                              type="button"
                            //   onClick={handleClearInChargeOfficerSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-24 text-right text-xs mr-2">အမည်</span>
                        <input type="text" name="inChargeOfficerName" value={formData.inChargeOfficerName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                      <div className="text-center text-xs font-bold pt-1">တာဝန်ခံဥပဒေအရာရှိ</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <input type="text" name="inChargeOfficerSubmitDate" value={formData.inChargeOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
  );
};